import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selected"]

  connect() {
    if (!this.hasSelectedTarget) return

    const track = this.element
    const stop = this.selectedTarget
    const stopIsHidden = stop.offsetLeft < track.scrollLeft ||
      stop.offsetLeft + stop.offsetWidth > track.scrollLeft + track.clientWidth

    if (stopIsHidden) track.scrollLeft = stop.offsetLeft - (track.clientWidth - stop.offsetWidth) / 2
  }
}
